import { Close } from '@mui/icons-material';
import {
  Alert,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid2,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { approvePayment } from '../../../../helpers/api';
import { openNotification } from '../../../../helpers/notification';

export default function ApprovePayment({ open, onClose, payment }) {
  const [saving, setSaving] = useState(false);
  const [comment, setComment] = useState('');
  const [sendCert, setSendCert] = useState(false);

  const handleApprovePayment = async () => {
    setSaving(true);
    try {
      const payload = {
        paymentId: payment?.paymentId,
        comment: comment,
        sendCertificate: sendCert,
      };

      const res = await approvePayment(payload);
      const { data, status } = res?.result;
      if (status?.code === '00') {
        openNotification({ type: 'success', message: status?.desc });
        onClose();
      } else {
        openNotification({ type: 'error', message: status?.desc });
      }
    } catch (error) {
      const errmsg = error?.data?.result?.data?.status?.desc;
      openNotification({ type: 'error', message: errmsg });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <DialogTitle variant="body1" sx={{ fontWeight: 600 }}>
          Approve Payment
        </DialogTitle>
        <Box ml="auto" px={3}>
          <IconButton onClick={() => onClose()} disabled={saving}>
            <Close />
          </IconButton>
        </Box>
      </Box>
      <DialogContent>
        <Alert severity="info" icon={false}>
          You are about to Approve payment
        </Alert>
        <br />
        <Grid2 container spacing={3}>
          <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
            <TextField
              multiline
              label="Write a comment"
              rows={4}
              fullWidth
              onChange={(e) => setComment(e.target.value)}
            />
          </Grid2>
          <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
            <FormControlLabel
              control={
                <Checkbox checked={sendCert} onChange={(e) => setSendCert(e.target.checked)} />
              }
              label={
                <Typography color="warning" variant="body1">
                  Auto send certificate on payment completion
                </Typography>
              }
              color="warning"
            />
          </Grid2>
        </Grid2>
      </DialogContent>
      <DialogActions sx={{ px: 2, pb: 2 }}>
        <Button
          type="button"
          variant="contained"
          color="info"
          disabled={saving}
          startIcon={saving && <CircularProgress size={20} />}
          sx={{ textTransform: 'none', borderRadius: 20 }}
          onClick={handleApprovePayment}
        >
          Yes, Approve
        </Button>
      </DialogActions>
    </Dialog>
  );
}
